<template>
  <div class="w-full flex justify-between items-center gap-4 sm:gap-8">
    <!-- Logo -->
    <a href="/" class="inline-block">
      <img :src="logoUrl" alt="Siteoplossing Logo" class="h-8 sm:h-10 md:h-15" />
    </a>

    <!-- Mobile CTA + Menu (hidden on /checkout) -->
    <div class="lg:hidden flex items-center justify-end gap-2">
      <button
        @click="$emit('toggle-drawer')"
        :aria-label="$t('components.header.openMenu')"
        class="btn btn-ghost btn-square ml-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>

    <!-- Desktop nav -->
    <ul class="menu menu-horizontal hidden lg:flex space-x-6 items-center">
      <li>
        <LanguageSelect :locale="locale" @update:locale="emit('update:locale', $event)" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import LanguageSelect from "@/components/LanguageSelect.vue";

defineProps<{
  logoUrl: string;
  locale: string;
  scrolled: boolean;
}>();
const emit = defineEmits<{
  (e: "toggle-drawer"): void;
  (e: "update:locale", value: string): void;
}>();
</script>

<style>
@keyframes bounce-slow {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}
.animate-bounce-slow {
  animation: bounce-slow 2s infinite;
}
</style>
